import { connect } from 'react-redux';

import type { State } from 'state';
import {
    changeEmailInput,
    checkLoginAction,
    forgotPassword,
    createPassword,
    loginAttempt,
    resetLogin,
} from 'state/actions/login';
import { getLoginAnnouncementLocale } from 'state/selectors/login';
import { withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import { LoginForm } from './login-form';

export default connect(
    (state: State) => ({
        loginAnnouncementLocale: getLoginAnnouncementLocale(state),
    }),
    {
        changeEmailInputAction: changeEmailInput,
        checkLoginActionAction: checkLoginAction,
        forgotPasswordAction: forgotPassword,
        createPasswordAction: createPassword,
        loginAttemptAction: loginAttempt,
        resetLoginAction: resetLogin,
    }
)(withAnalyticsContext({ componentName: 'loginForm' })(withAnalyticsEvents()(LoginForm)));
